const isEqualCode = `import { isEqual } from 'cristatus';

const isEqual = isEqual(1, 1); //true
`;

export default isEqualCode;
